const Export2Doc = elementHtml => {

       var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
            "xmlns:w='urn:schemas-microsoft-com:office:word' "+
            "xmlns='http://www.w3.org/TR/REC-html40'>"+
            "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
       var postHtml = "</body></html>";
    var html = preHtml + elementHtml + postHtml

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword',
    })

    var url =
        'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html)

    const filename = 'job-description.doc'
    var downloadLink = document.createElement('a')

    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename)
    } else {
        downloadLink.href = url
        downloadLink.download = filename
        downloadLink.click()
    }
}

export default {
    Export2Doc,
}
